// extracted by mini-css-extract-plugin
export default {"container":"product-list-grid__container___1QlRZ"};